var map = {
	"./all-done.svg": "7333f",
	"./failed.svg": "de08",
	"./icons/check-mark.svg": "26777",
	"./icons/deposit.svg": "dec4",
	"./icons/egwi.svg": "4935",
	"./icons/extraPayment.svg": "7696",
	"./icons/inventory.svg": "f161",
	"./icons/leaving.svg": "8869",
	"./icons/picture.svg": "4092",
	"./icons/rent.svg": "ef1f",
	"./icons/staying.svg": "4ada",
	"./icons/studentTax.svg": "2f28",
	"./icons/undecided.svg": "1a94",
	"./kotkip.svg": "ba7a",
	"./mollie.svg": "df2f",
	"./success.svg": "2764",
	"./twikey.svg": "9fdd",
	"./upgrade-estate.svg": "c551",
	"./upkot-old-logo.svg": "abfc",
	"./upkot.svg": "1e6a",
	"./upliving.svg": "be49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";